module.exports = __webpack_public_path__ + "img/pc_steps.1b9756e5.png";